import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useDictionary from '@ui/hooks/useDictionary';
import ButtonComponent from '../Button/Button.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ lang, message, onClose }: IProps) => {
    const getWord = useDictionary();

    return (
        <Box className="modal-notification" component="section">
            <IconButton className="close-btn" onClick={onClose}>
                <CloseIcon className="close-btn__ico" />
            </IconButton>
            <Typography className="modal-notification__title" variant="h6">
                {getWord(message)}
            </Typography>
            <Box className="modal-notification__btn-wrap">
                <ButtonComponent label="ok" lang={lang} onClick={onClose} />
            </Box>
        </Box>
    );
};

const ModalNotificationComponent = React.memo(Component);

export default ModalNotificationComponent;
